import { createSlice } from '@reduxjs/toolkit';

/* eslint-disable no-param-reassign */

/**
 * Inventory fetched + normalized server-side on the AI-bot SSR path
 * (US1994526 / TA4063706). The server fetch (TA4063705) seeds it via
 * store.dispatch(setSeoVehicleData(...)), the same way server/store.js seeds
 * layout, widgetInfo, etc. The serialized state is restored on the client by
 * ws-scripts' browser.jsx, so it is identical on the server render and the
 * client's first render — which is what lets the static SeoVehicleCards subtree
 * hydrate cleanly.
 *
 * Empty by default, so non-bot (shopper / ordinary-SEO) requests are unaffected
 * — the widget falls through to its existing skeleton → VehicleCards path.
 *
 * `baseUrl` + `parameterMap` are seeded here (from requestData, server-side) so
 * the static SeoPagination builds its crawlable hrefs from this fully-serialized
 * slice rather than from useRequestData() — ws-scripts serializes only a subset
 * of requestData to the client (uri/parameterMap are dropped), so reading them
 * from the hook would render path-less hrefs on the client and mismatch the SSR
 * markup. Sourcing them from the slice keeps server + client identical (AC5).
 */
const initialState = {
	inventory: [],
	pageInfo: {},
	baseUrl: '',
	parameterMap: {}
};

const seoVehicleDataSlice = createSlice({
	name: 'seoVehicleData',
	initialState,
	reducers: {
		setSeoVehicleData(state, action) {
			return { ...state, ...action.payload };
		}
	}
});

export const { setSeoVehicleData } = seoVehicleDataSlice.actions;

export default seoVehicleDataSlice.reducer;
